
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import selectedClient from "../components/customer-filter.vue";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine } from "@common/src/utils/common";
import NoticeChannel from "@common/src/components/scope/notice-channel/index.vue";
import { addCurrencyUnit } from "@common/src/utils/tools";
import CampaignMobileCheck from "@common/src/components/scope/campaign-mobile-check/index.vue";
import t from "@common/src/i18n/t";
const base = namespace("base");
const coupon = namespace("coupon");
const app = namespace("app");
@Component({
  components: {
    selectedClient,
    NoticeChannel,
    CampaignMobileCheck
  }
})
@Table("loadListData", { pageSize: 5 })
export default class SendCoupon extends Vue {
  @coupon.Mutation setDialog;
  @coupon.Action getDetail;
  @coupon.Action distributeCoupons;
  @base.Action queryStoreMessageBalance;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @app.State btnLoading;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  //计算属性
  get breadData() {
    return [
      { name: t("marketing.discount-coupon"), path: "/marketing/discount-coupon" },
      { name: t("v210831.issue-coupons") }
    ];
  }
  notifyMethods = [];
  tableData = [];
  loading = false;
  dialogVisible = true;
  currentPage4 = 4;
  wechatChecked = false;
  messageChecked = false;
  searchForm = {
    cardTemplateName: "",
    cardType: ""
  };
  conponDetail = {
    activityName: undefined,
    remainingQuantity: undefined
  };
  created() {
    this.init();
  }

  init() {
    this.getDetail({ activityCode: this.$route.params.activityCode }).then(res => {
      this.conponDetail = res.data;
    });
  }
  remove(row) {
    this.loading = true;
    this.tableData = this.tableData.filter(item => {
      return item.customerCode !== row.customerCode;
    });
    this.loading = false;
  }
  mobilePassed: boolean = true;
  sendCoupon() {
    if (!this.tableData.length) {
      this.$message.error(t("v210831.please-select-a-client-first"));
      return;
    }
    if (this.notifyMethods.includes("sms")) {
      // 如果选择了短信
      this.queryStoreMessageBalance().then(data => {
        //  data.data.smsBalance
        console.log("[  data.data.smsBalance ]", Number(data.data.smsBalance) < this.tableData.length);
        if (Number(data.data.smsBalance) < this.tableData.length) {
          this.$message.warning(t("v210831.insufficient-sms-balance"));
          return;
        } else {
          this.passRight();
        }
      });
    } else {
      this.passRight();
    }
  }
  passRight() {
    // 点击发放
    this.btnStartLoading();
    this.distributeCoupons({
      activityCode: this.$route.params.activityCode,
      customerList: this.tableData,
      notifyMethods: this.notifyMethods
    })
      .then(() => {
        this.$message.success(t("v210831.coupon-issued-successfully"));
        this.$router.push("/marketing/discount-coupon");
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  clickTarget() {
    this.setDialog(true);
  }
  getList(arr) {
    this.loading = true;
    let newArr = this.tableData.concat(arr);
    var result = [];
    var obj = {};
    for (var i = 0; i < newArr.length; i++) {
      if (!obj[newArr[i].customerCode]) {
        result.push(newArr[i]);
        obj[newArr[i].customerCode] = true;
      }
    }
    this.tableData = result;
    this.loading = false;
  }
  get wxSum(): number {
    return this.tableData.filter(item => item.weixinMiniProgramFlag).length || 0;
  }
}
